import { Container } from './building-blocks';

export class RuleVersionBatchChanges {
    inserts: Container[];
    updates: Container[];
    deletes: Container[];
    ruleName: string;
}
